import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import { appName } from "../app.json";
import { REST_PASSWORD } from "../queries/staff.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../partials/loading.jsx";
import AlertMessage from "../partials/alertMessage.jsx";

function ForgotPassword() {
  const emailRef = useRef();
  const [sendFunc, { loading, error, data }] = useMutation(REST_PASSWORD, {
    onCompleted: (data) => {
      if (data.ChangePassword && emailRef.current) {
        emailRef.current.value = "";
      }
    },
  });
  return (
    <div className="">
      <Helmet>
        <title>Password Reset | {appName}</title>
        <link rel="stylesheet" href="./main/css/extra_pages.css"></link>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css"
        ></link>
      </Helmet>
      <div className="login-container">
        <div className="logo-left">clinicalspec</div>
        <div className="row justify-content-center">
          <div className="wrap-login100" style={{ margin: "100px 0 10px 0" }}>
            <AlertMessage message={data && data.ChangePassword.message} />
            <AlertMessage message={error && error.message} failed={true} />
            <form
              className="login100-form validate-form"
              onSubmit={(e) => {
                e.preventDefault();
                sendFunc({
                  variables: { email: emailRef.current.value },
                });
              }}
            >
              <span className="login100-form-logo">
                <img alt="logo" src="/assets/img/logo.jpeg" />
              </span>

              <p className="text-center txt-small-heading">Password Reset</p>
              <div
                className="wrap-input100 validate-input"
                data-validate="Enter username"
              >
                <input
                  className="input100"
                  type="email"
                  required
                  name="email"
                  ref={emailRef}
                  placeholder="Enter email address"
                />
                <span
                  className="focus-input100"
                  data-placeholder="&#xf207;"
                ></span>
              </div>
              <div className="text-center">
                <LoadingSpinner loading={loading} bar={true} />
              </div>
              <div className="container-login100-form-btn">
                <button type="submit" className="login100-form-btn">
                  Send
                </button>
              </div>
              <div className="text-center m-t-20">
                <NavLink to="login">
                  <i className="fa fa-arrow-left"></i>
                  Back to Login
                </NavLink>
              </div>
              <hr />
              <center>
                <p style={{ marginTop: "5em", fontSize: "12px" }}>
                  For any query, please contact us on <b>+447367533331</b> or
                  email us on <b>info@clinicalspec.com</b>
                </p>
              </center>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
